export enum REST_METHODS {
  PATCH = 'PATCH',
  POST = 'POST',
  GET = 'GET',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum RestAuthType {
  None = 'none',
  UserRole = 'user-role',
  Token = 'token',
}
